var render, staticRenderFns
import script from "./helpSlideout.vue?vue&type=script&lang=js&"
export * from "./helpSlideout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dev.pixflow.app/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7c88fb29', component.options)
    } else {
      api.reload('7c88fb29', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/helpSlideout.vue"
export default component.exports